import { useMediaQuery } from "react-responsive";

export const isMobileView = () => {
	return useMediaQuery({ maxWidth: 768 });
};
